import { render, staticRenderFns } from "./centnerPage.vue?vue&type=template&id=341c9e1e"
import script from "./centnerPage.vue?vue&type=script&lang=js"
export * from "./centnerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports